import AgyleDialog from "../../../../components/modal/agyleDialog";
import React, { useEffect, useState } from "react";
import { Grid, Stack } from "@mui/material";
import moment from "moment";
import API from "../../../../app/api";
import AgyleLoadingSpinner from "../../../../components/other/agyleLoadingSpinner";
import Typography from "@mui/material/Typography";
import AgyleButton from "../../../../components/ui/buttons/agyleButton";
import TruncatedText from "../../../../components/ui/text/truncatedText";
import { isArray, filter, isEmpty } from "lodash";
import InformationBox from "../../../../components/other/informationBox";
import { useTranslation } from "react-i18next";
import { SLOT_STATUSES } from "../../../appointments/utils/constants/appointmentSessionConstants";

export default function AppointmentsListDialog({
  patient,
  open,
  hospital,
  onClose,
  onSelect,
}) {
  const { t } = useTranslation();

  const [resultsLoading, setResultsLoading] = useState(false);
  const [appointmentsList, setAppointmentsList] = useState([]);

  useEffect(() => {
    const fetchData = async (ptId, hospitalId) => {
      setResultsLoading(true);
      try {
        const filterStr = `patientId=${ptId}${hospitalId ? `&hospitalId=${hospitalId}` : ""}`;

        const apiResponse = await API.getAppointmentSlots(
          moment(),
          moment().add(1, "month"),
          false,
          filterStr,
        );

        if (isArray(apiResponse)) {
          const filtered = filter(apiResponse, (slot) => {
            return (
              slot.patientId === patient.hospitalNumber &&
              slot.status === SLOT_STATUSES.NOT_REGISTERED.value &&
              !!slot.patient
            );
          });

          setAppointmentsList(filtered || []);
        }
      } catch (e) {
      } finally {
        setResultsLoading(false);
      }
    };

    if (open && patient?.hospitalNumber) {
      fetchData(patient?.hospitalNumber, hospital?.__id);
    }
  }, [patient?.hospitalNumber, open, hospital?.__id]);

  return (
    <AgyleDialog
      title="Select appointment to update"
      open={open}
      onClose={() => onClose()}
      disableSave
      width={"md"}
      fullWidth
    >
      <Grid container gap={1}>
        {!resultsLoading &&
          !isEmpty(appointmentsList) &&
          appointmentsList.map((app, appIdx) => {
            return (
              <Grid item xs={12} key={appIdx}>
                <Stack direction="row" gap={2} alignItems="center">
                  <Typography style={{ fontWeight: 500 }}>
                    {moment(app.startDate).format("DD/MM/YYYY")}{" "}
                    {moment(app.startDate).format("HH:mm")} -{" "}
                    {moment(app.endDate).format("HH:mm")}
                  </Typography>

                  <TruncatedText text={app.description} fw={600} />

                  <AgyleButton
                    variant="contained"
                    onClick={() => onSelect(patient, app)}
                    style={{ marginLeft: "auto" }}
                  >
                    Select
                  </AgyleButton>
                </Stack>
              </Grid>
            );
          })}

        {resultsLoading && <AgyleLoadingSpinner />}

        {!resultsLoading && isEmpty(appointmentsList) && (
          <InformationBox type="info">
            {t("Appointments have not been scheduled on incoming month.")}
          </InformationBox>
        )}
      </Grid>
    </AgyleDialog>
  );
}
